export const AUTH_USER_KEY = "authUser";
